import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { amazonReleaseDateReportFormIsOpen, amazonReleaseDateSubmittedFilters } from "../@signals"


export default function useAmazonReleaseDateReportForm(dataRow={}) {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal('')
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])
    const includeOnlyNewProducts = useSignal('No')
    const amazonReleaseDateStatus = useSignal(null)

    const resetFormData = () => {
        nameReport.value = ''
        frequency.value = null
        emailsReport.value = [userEmail]
    }

    const handleOpenForm = () => {
        amazonReleaseDateReportFormIsOpen.value = true
    }

    const normalizedConditionsFilters = () => {
        return {
            status: amazonReleaseDateStatus.value,
            includeOnlyNewProducts: includeOnlyNewProducts.value === 'Yes',
        }
    }

    const handleSendToBack = () => {
        let apiUrl =`${WEBBACK_V2_API}/reports/create`

        if (frequency.value === 'now') {
            apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
        }

        const payload = {
            nameReport: nameReport.value,
            frequency: frequency.value,
            emailsReport: emailsReport.value.join(","),
            reportType: 'amazonReleaseDate',
            conditions: normalizedConditionsFilters(),
            filters: {
                country: amazonReleaseDateSubmittedFilters.value.country, retailer: amazonReleaseDateSubmittedFilters.value.retailer,
                brand: amazonReleaseDateSubmittedFilters.value.brand, skuGroup: amazonReleaseDateSubmittedFilters.value.skuGroup,
                sku: amazonReleaseDateSubmittedFilters.value.sku, id_customer: userCustomer
            }
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: 'Error: Please try again later.',
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport: nameReport,
        frequency: frequency,
        emailsReport: emailsReport,
        amazonReleaseDateStatus: amazonReleaseDateStatus,
        includeOnlyNewProducts: includeOnlyNewProducts
    }
}